import { Guid } from "guid-typescript";
import { IMessage } from "../../IMessage";

//Generated code, do not modify

export class GetEventTypeQuery implements IMessage {
    id!: Guid;

    public constructor(init?: Partial<GetEventTypeQuery>) {
        Object.assign(this, init);
    }

    getMethod = () => "GET";

    getUrl = () => `/admin/event-types/${this.id.toString()}`;

    getQueryString = () => undefined;

    getBody = () => undefined;
}